import { type SxProps, type Theme } from "@mui/material";
import { Text, TextSkeleton } from "@src/appV2/redesign/system/ui-components";

export interface TotalPayLabelProps {
  /**
   * The formatted total pay for the shift.
   */
  totalPay: string | undefined;
  /**
   * Whether the pay data is being fetched.
   */
  isLoading?: boolean;
  /**
   * Custom styles to apply to the component.
   */
  sx?: SxProps<Theme>;
  /**
   * The size of the text.
   */
  size?: "small" | "medium";
}

// TODO: Move to cbh-core as fast follow up to https://linear.app/clipboardhealth/issue/SPRTA-1362/update-shift-details-bottom-sheet
export function TotalPayLabel(props: TotalPayLabelProps) {
  const { totalPay, isLoading, sx, size = "small" } = props;

  if (isLoading) {
    return <TextSkeleton variant={size === "small" ? "body2" : "body1"} width="6ch" sx={sx} />;
  }

  return (
    <Text variant={size === "small" ? "body2" : "body1"} sx={sx}>
      {totalPay}
    </Text>
  );
}
